import { DeleteCompanyUseCase } from 'shared/domain/company/types/useCases';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { CompanyHttpDeleteRequestModel } from '../httpQueue/company/types';

export class CompanyDeleter implements DeleteCompanyUseCase {
  constructor(
    private addRequest: (
      request: CompanyHttpDeleteRequestModel
    ) => Promise<any>
  ) {}
  async execute({
    companyId,
    uniqueId,
    projectId,
  }: {
    companyId: string;
    uniqueId: string;
    projectId: string;
  }): Promise<void> {
    debugLog('DeleteCompanyUseCase', companyId);

    const request: CompanyHttpDeleteRequestModel = {
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        companyId: companyId,
        projectId,
        uniqueId: uniqueId,
      },
      url: `/project/${projectId}/company/${companyId}`,
      entityType: HttpRequestModelType.company,
      status: HttpRequestStatus.NEW,
    };
    await this.addRequest(request);
  }
}

export const companyDeleter = new CompanyDeleter(addRequest);
